import {
  RESET_STATE_ACTION_TYPE,
  resetStateAction,
} from './resetState.action';

export {
  RESET_STATE_ACTION_TYPE,
  resetStateAction,
};
